
export default {
  name: 'icon-ticket',
};
